module.exports = __webpack_public_path__ + "img/drums.accd5bfb.jpg";